import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Card, Divider, Typography, TextButton } from 'bonfire-kindling';

const DashboardOverviewMetricsCard = ({ title, to, count, testId }) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ width: '100%', height: '100%' }}>
      <Box
        sx={{
          p: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="subtitle2" sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' } }}>
          {title}
        </Typography>
        <TextButton
          component={RouterLink}
          to={to}
          label={t('dashboard.overview.metrics.view')}
          variant="outline"
        />
      </Box>
      <Divider />
      <Box sx={{ p: 3 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontSize: '2rem', textAlign: 'center', color: theme => theme.palette.primary.main }}
          data-testid={testId}
        >
          {count}
        </Typography>
      </Box>
    </Card>
  );
};

export default DashboardOverviewMetricsCard;
